import { render, staticRenderFns } from "./TestOcr.vue?vue&type=template&id=d5d70e12&scoped=true&"
import script from "./TestOcr.vue?vue&type=script&lang=js&"
export * from "./TestOcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d70e12",
  null
  
)

export default component.exports